import type { ReportNodeType } from "components/_Modals/ProjectDownloadModal/ReportsCheckboxes/types";

export const projectFolderReportConfig: ReportNodeType[] = [
  {
    id: "REPORTS",
    translationKey: "REPORTS",
    reportItemsWrapper: true,
    selected: false,
    children: [
      {
        id: "PROJECT",
        translationKey: "PROJECT_REPORT",
        selected: false,
      },
      {
        id: "SPECIFICATION_TEXTS",
        translationKey: "SPECIFICATION_TEXTS",
        selected: false,
      },
    ],
  },
  {
    id: "BOM_REPORTS",
    translationKey: "BOM_REPORTS",
    reportItemsWrapper: true,
    selected: false,
    children: [
      {
        id: "BOM_COMPACT",
        translationKey: "BOM_COMPACT",
        selected: false,
      },
      {
        id: "BOM_UNMITIGATED",
        translationKey: "BOM_UNMITIGATED",
        selected: false,
      },
    ],
  },
];

export const wizardReportConfig: ReportNodeType[] = [
  {
    id: "TENDER_TEXT",
    translationKey: "TENDER_TEXT_REPORT",
    selected: false,
  },
];
